<template>
    <div class="MainBox" @click.stop="SelectActive(-1, $self)">
        <div class="TableHead">
            <ul class="TableHeadLeft">
                <li class="TableHeadLeftRow btnStyleTwo blueBackColor btnRadius" @click="HandleModel(true)"><span
                        class="icon iconfont iconicon-test20"></span>新增绑定</li>
            </ul>
            <ul class="clear"></ul>
        </div>

        <div class="TableMain">
            <K-Transition :isLoding="isLoding" :subHint="subHint" v-if="!datas"></K-Transition>
            <table class="table StripeTable" v-else>
                <thead>
                    <tr>
                        <th>编号</th>
                        <th>学生姓名</th>
                        <th>性别</th>
                        <th>年级</th>
                        <th>班级</th>
                        <th>家长电话</th>
                        <th>状态</th>
                        <th>创建时间</th>
                        <th>操作</th>
                    </tr>
                </thead>
                <tbody class="TRHoverStyle">
                    <tr v-for="(item, index) in datas" v-bind:key="index">
                        <td v-text="item.id"></td>
                        <td v-text="item.student_name"></td>
                        <td v-text="GenderText(item.gender)"></td>
                        <td v-text="item.grade"></td>
                        <td v-text="item.class"></td>
                        <td v-text="item.parent_phone"></td>
                        <td>
                            <el-switch :active-value="1" :inactive-value="0" v-model="item.status"
                                @change="statusChange(item)"></el-switch>
                        </td>
                        <td v-text="item.create_at"></td>
                        <td>
                            <div class="btnArray">
                                <a class="btnStyleTwo btnRadius greenBackColor" @click="HandleModel(true, item)">编辑</a>
                                <a class="btnStyleTwo btnRadius redBackColor" @click="deleteHandle(item)">删除</a>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>

            <!-- 分页器 -->
            <K-Paging :page="page" :totalPages="totalPages" @ChangePage="ChangePage" @SkipPage="SkipPage"></K-Paging>

        </div>

        <!-- 新增/编辑窗口 -->
        <div class="ModalBox" v-if="ModelShow">
            <div class="ModalMain">
                <div class="ModalMainHead">
                    {{ FormDatas.id ? '编辑' : '新增' }}学生绑定信息
                    <span class="icon iconfont iconicon-test29 ModalMainHeadClose feedback"
                        @click="HandleModel(false)"></span>
                </div>
                <div class="ModalMainBox">
                    <ul class="FormStyleTwo">
                        <li class="FormStyleTwoRow">
                            <p class="FormStyleTwoTitle">学生照片</p>
                            <p><K-ImagePicker v-model="FormDatas.photo_url" :width="100" :height="100"
                                    tip="点击上传或从图片空间选择"></K-ImagePicker></p>
                        </li>
                        <li class="FormStyleTwoRow">
                            <p class="FormStyleTwoTitle"><i>*</i>绑定码</p>
                            <p><input v-model="FormDatas.code" placeholder="请输入绑定码" /></p>
                        </li>
                        <li class="FormStyleTwoRow">
                            <p class="FormStyleTwoTitle"><i>*</i>学生姓名</p>
                            <p><input v-model="FormDatas.student_name" placeholder="请输入学生姓名" /></p>
                        </li>
                        <li class="FormStyleTwoRow">
                            <p class="FormStyleTwoTitle"><i>*</i>家长电话</p>
                            <p><input v-model="FormDatas.parent_phone" type="number" maxlength="11" placeholder="请输入家长电话" /></p>
                        </li>
                        <li class="FormStyleTwoRow">
                            <p class="FormStyleTwoTitle">性别</p>
                            <p>
                                <el-select v-model="FormDatas.gender" placeholder="请选择">
                                    <el-option label="未选择" :value="0"></el-option>
                                    <el-option label="男" :value="1"></el-option>
                                    <el-option label="女" :value="2"></el-option>
                                </el-select>
                            </p>
                        </li>
                        <li class="FormStyleTwoRow">
                            <p class="FormStyleTwoTitle">年级</p>
                            <p><input v-model="FormDatas.grade" placeholder="请输入年级" /></p>
                        </li>
                        <li class="FormStyleTwoRow">
                            <p class="FormStyleTwoTitle">班级</p>
                            <p><input v-model="FormDatas.class" placeholder="请输入班级" /></p>
                        </li>
                        <li class="FormStyleTwoRow">
                            <p class="FormStyleTwoTitle">校服寄语</p>
                            <p><textarea v-model="FormDatas.message" placeholder="请输入校服寄语"></textarea></p>
                        </li>
                        <!-- <li class="FormStyleTwoRow">
              <p class="FormStyleTwoTitle">启用电话找回</p>
              <p><el-switch :active-value="1" :inactive-value="0" v-model="FormDatas.enable_phone_recovery"></el-switch></p>
            </li>
            <li class="FormStyleTwoRow">
              <p class="FormStyleTwoTitle">状态</p>
              <p><el-switch :active-value="1" :inactive-value="0" v-model="FormDatas.status"></el-switch></p>
            </li> -->

                        <li class="FormStyleTwoRow">
                            <p class="FormStyleTwoTitle">出生日期</p>
                            <p>
                                <el-date-picker v-model="FormDatas.birthday" type="date" value-format="yyyy-MM-dd"
                                    placeholder="请选择出生日期"></el-date-picker>
                            </p>
                        </li>
                        <li class="FormStyleTwoRow">
                            <p class="FormStyleTwoTitle">身高</p>
                            <p><span class="UnitInput"><input v-model="FormDatas.height"
                                        placeholder="请输入身高" type="number" /><i>cm</i></span></p>
                        </li>
                        <li class="FormStyleTwoRow">
                            <p class="FormStyleTwoTitle">体重</p>
                            <p><span class="UnitInput"><input v-model="FormDatas.weight"
                                        placeholder="请输入体重" type="number" /><i>kg</i></span></p>
                        </li>
                        <li class="FormStyleTwoRow">
                            <p class="FormStyleTwoTitle">血型</p>
                            <p>
                                <el-select v-model="FormDatas.blood_type" placeholder="请选择">
                                    <el-option label="A型" value="A型"></el-option>
                                    <el-option label="B型" value="B型"></el-option>
                                    <el-option label="AB型" value="AB型"></el-option>
                                    <el-option label="O型" value="O型"></el-option>
                                    <el-option label="未知" value="未知"></el-option>
                                </el-select>
                            </p>
                        </li>
                        <li class="FormStyleTwoRow">
                            <p class="FormStyleTwoTitle">过敏史</p>
                            <p><textarea v-model="FormDatas.allergy_history" placeholder="请输入过敏史"></textarea></p>
                        </li>
                        <li class="FormStyleTwoRow">
                            <p class="FormStyleTwoTitle">在服药物</p>
                            <p><textarea v-model="FormDatas.taking_medication" placeholder="请输入在服药物"></textarea></p>
                        </li>
                    </ul>
                </div>
                <div class="ModalMainFoot">
                    <div class="ModalMainFootRight btnArray">
                        <a class="btnStyleTwo btnRadius grayBackColor" @click="HandleModel(false)"
                            v-text="$t('c.Common.Cancel')"></a>
                        <a class="btnStyleTwo btnRadius blueBackColor" @click="SubmitForm()"
                            v-text="$t('c.Common.Confirm')"></a>
                    </div>
                </div>
            </div>
        </div>

        <!-- loading -->
        <K-Loading v-if="loading"></K-Loading>

        <!-- toast -->
        <K-Toast :Toast="Toast" @ChangeToast="ChangeToast"></K-Toast>

        <!-- 确认框 -->
        <K-Confirm :Confirm="Confirm" @ConfirmBackFun="ConfirmBackFun"></K-Confirm>

    </div>
</template>

<script>
var self;
import axios from 'axios'
import Paging from '@/components/common/Paging.vue'
import Transition from '@/components/common/Transition.vue'
import Loading from '@/components/common/Loading.vue'
import Confirm from '@/components/common/Confirm.vue'
import Toast from '@/components/common/Toast.vue'
import ImagePicker from '@/components/common/ImagePicker.vue'

//新增/编辑表单默认值（对象必须先在 data 中声明完整字段，保证响应式）
const DefaultFormDatas = {
    id: '',
    code: '',
    student_name: '',
    gender: 0,
    grade: '',
    class: '',
    photo_url: '',
    message: '',
    parent_phone: '',
    enable_phone_recovery: 1,
    birthday: '',
    height: '',
    weight: '',
    blood_type: '',
    allergy_history: '',
    taking_medication: '',
    status: 1
}

export default {
    name: 'StudentBinding',
    components: {
        'K-Paging': Paging,
        'K-Transition': Transition,
        'K-Confirm': Confirm,
        'K-Loading': Loading,
        'K-Toast': Toast,
        'K-ImagePicker': ImagePicker
    },
    data() {
        return {
            $self: null,
            page: 1,
            pageSize: 20,
            subHint: '数据加载中...',
            isLoding: true,
            loading: false,
            Toast: {
                state: false,
                type: 0,
                txt: null
            },
            Confirm: {
                state: false,
                txt: null,
                style: 1
            },
            totalPages: 1,
            datas: null,
            id: null,
            ModelShow: false,
            FormDatas: Object.assign({}, DefaultFormDatas)
        }
    },
    created() {
        this.$self = this;
    },
    beforeDestroy() {
    },
    mounted() {
        this.GetList();
    },
    methods: {
        ToastFun(type, txt) {
            this.Toast.state = true;
            this.Toast.type = type;
            this.Toast.txt = txt;
        },
        ChangeToast() {
            this.Toast.state = false;
        },
        GenderText(gender) {
            if (gender == 1) return '男';
            if (gender == 2) return '女';
            return '未选择';
        },
        ChangePage(data) {  //上下翻页
            if (data.te == 1) {
                if (this.page > 1) {
                    this.page--
                }
            } else {
                if (this.page < this.totalPages) {
                    this.page++
                }
            }
            this.GetList();
        },
        SkipPage(data) {  //跳转分页
            this.page = data.ix;
            this.GetList();
        },
        HandleModel(status, item) {  //隐藏显示新增/编辑窗口
            this.ModelShow = status;
            if (status) {
                Object.assign(this.FormDatas, item ? JSON.parse(JSON.stringify(item)) : DefaultFormDatas);
            }
        },
        GetList() {
            this.datas = null;
            this.isLoding = true;
            this.subHint = "数据加载中...";
            axios.get(this.GetServerUrl(1) + "school_uniform_binding", { params: { page: this.page, pageSize: this.pageSize } })
                .then((response) => {
                    this.isLoding = false;
                    let res = response.data;
                    let list = [];
                    let total = 0;
                    //兼容 meta.data + last_page 与 data.data 两种返回结构
                    if (res.meta && res.meta.data) {
                        list = res.meta.data;
                        total = res.meta.total || res.meta.last_page * this.pageSize;
                    } else if (res.data && res.data.data) {
                        list = res.data.data;
                        total = res.data.total || 0;
                    } else if (Array.isArray(res.data)) {
                        list = res.data;
                    }
                    if (list.length) {
                        this.datas = list;
                        this.totalPages = Math.ceil(total / this.pageSize) > 1 ? Math.ceil(total / this.pageSize) : 1;
                    } else {
                        this.datas = [];
                        this.subHint = "数据为空";
                    }
                }).catch((error) => {
                    this.subHint = this.ErrorHint(error);
                    this.isLoding = false;
                })
        },
        statusChange(item) {
            this.loading = true;
            axios({
                method: "PUT",
                url: this.GetServerUrl(1) + "school_uniform_binding/" + item.id,
                data: { status: item.status }
            }).then((response) => {
                this.loading = false;
                this.ToastFun(0, response.data.message || "状态更新成功");
                this.GetList();
            }).catch((error) => {
                this.loading = false;
                this.ToastFun(2, this.ErrorHint(error));
                this.GetList();
            })
        },
        SubmitForm() {
            if (!this.FormDatas.code) {
                this.ToastFun(1, "码标不能为空！");
                return;
            }
            if (!this.FormDatas.student_name) {
                this.ToastFun(1, "学生姓名不能为空！");
                return;
            }
            if (!this.FormDatas.parent_phone) {
                this.ToastFun(1, "家长电话不能为空！");
                return;
            }
            let method = "POST";
            let url = this.GetServerUrl(1) + "school_uniform_binding";
            if (this.FormDatas.id) {  //编辑
                method = "PUT";
                url = this.GetServerUrl(1) + "school_uniform_binding/" + this.FormDatas.id;
            }
            this.loading = true;
            axios({
                method: method,
                url: url,
                data: this.FormDatas
            }).then((response) => {
                this.loading = false;
                this.ToastFun(0, response.data.message || "成功");
                this.HandleModel(false);
                this.GetList();
            }).catch((error) => {
                this.loading = false;
                this.ToastFun(2, this.ErrorHint(error));  //弹窗提醒
            })
        },
        deleteHandle(item) {
            this.id = item.id;
            this.Confirm.state = true;
            this.Confirm.txt = "是否确定删除该学生绑定信息吗？"
        },
        ConfirmBackFun(data) {
            this.Confirm.state = data.state;
            if (data.state) {
                this.Confirm.state = false;
                this.loading = true;
                axios({
                    method: "delete",
                    url: this.GetServerUrl(1) + `school_uniform_binding/${this.id}`
                }).then((response) => {
                    this.loading = false;
                    this.ToastFun(0, response.data.message || "删除成功");  //弹窗提醒
                    this.GetList();
                }).catch((error) => {
                    this.loading = false;
                    this.ToastFun(2, this.ErrorHint(error));  //弹窗提醒
                })
            }
        }
    }
}
</script>

<style scoped>
.FormGroupTitle {
    background-color: #f5f7fa;
    padding: 10px 15px;
    font-weight: bold;
    color: #666;
}

.FormGroupTitle p {
    margin: 0;
}

/* 统一弹窗内表单项宽度（性别、出生日期、带单位输入框均保持 515px） */
.ModalMainBox .FormStyleTwo .el-select,
.ModalMainBox .FormStyleTwo .el-date-editor,
.ModalMainBox .FormStyleTwo .UnitInput {
    width: 515px !important;
}

.ModalMainBox .FormStyleTwo .el-select .el-input__inner,
.ModalMainBox .FormStyleTwo .el-date-editor .el-input__inner {
    width: 100% !important;
}

/* 带单位输入框 */
.UnitInput {
    position: relative;
    display: inline-block;
}

.UnitInput input {
    width: 100% !important;
    /* padding-right: 50px !important; */
}

.UnitInput i {
    position: absolute;
    right: 12px;
    top: 0;
    height: 35px;
    line-height: 35px;
    font-style: normal;
    font-size: 14px;
    color: #909399;
}
</style>
